export default "__VITE_ASSET__Cy$43yNn__"